import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Container = styled(Link)`
  border-radius: 4px;
  background: #ff6900;
  border: none;
`;
